var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportAsPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 12.555 10.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16813",
    "data-name": "Group 16813",
    transform: "translate(-2233 453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_",
    transform: "translate(2233 -453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    d: "M136.6,79.556h-5.4a4.593,4.593,0,0,1,1.4,1.27h4a.333.333,0,0,1,.332.332v6.071a.333.333,0,0,1-.332.332h-6.071a.333.333,0,0,1-.332-.332V83.184a2.968,2.968,0,0,0-.479-.2,1.225,1.225,0,0,1-.6.707,1.211,1.211,0,0,1-.192.072v3.463a1.6,1.6,0,0,0,1.6,1.6H136.6a1.6,1.6,0,0,0,1.6-1.6V81.158A1.6,1.6,0,0,0,136.6,79.556Z",
    transform: "translate(-125.645 -78.788)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    d: "M3.283,52.591a3.788,3.788,0,0,1,3.11,1.752.322.322,0,0,0,.593-.169v-.038a3.792,3.792,0,0,0-3.7-3.789v-.6a.376.376,0,0,0-.588-.31L.146,51.18a.336.336,0,0,0,0,.554L2.693,53.5a.375.375,0,0,0,.59-.309Z",
    transform: "translate(0 -49.37)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportAsPdf);
export default __webpack_public_path__ + "static/media/export-as-pdf.1c3d7078edd4d1ffc9f954412b37c9b7.svg";
export { ForwardRef as ReactComponent };